import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  CircularProgress,
  Modal,
  Backdrop,
  Fade,
  Box,
  Button,
  List,
  ListItem,
  Typography,
  ButtonGroup,
  Tabs,
  Tab,
  Paper,
  Collapse,
  Grid,
} from '@material-ui/core/';
import { useHistory } from 'react-router-dom';
import TableRegister from '../../components/TableRegister';
import MapMarker from '../../components/MapMarker';
import { useStyles } from './style';
import { toDate } from '../../utils/formatDate';
import Colors from '../../components/Colors';
import { IncidentImages, IncidentResponse, Veiculo } from '../../@types/incidentTypes';
import { fetchIncidentById, getImagesOfIncident } from '../../actions/incidentActions';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';


const RegisterIncident: React.FC = () => {
  const styles = useStyles();
  const [damageFormColapseControl, setDamageFormColapseControl] = useState<boolean>(
    false,
  );
  const { pathId } = useParams<{ pathId: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [active, setActive] = useState<number>(0);
  const [variant, setVariant] = useState<'text' | 'outlined' | 'contained' | undefined>(
    'text',
  );
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });

  const [register, setRegister] = useState<IncidentResponse>({
    uuid: '',
    data: {
      driverVeiculo: [],
      driverVia: [],
      driverVitima: [],
      driverIncidenteDetails: {
        'Superfície da Pista': '',
        Local: '',
        Natureza: '',
        Jurisdição: '',
        Tempo: '',
        'Hora informada': '',
        Severidade: '',
        'Endereço 1': '',
        'Controle de Tráfego': '',
        Interseção: '',
        Iluminação: '',
        'Endereço 2': '',
        'Código do Acidente': '',
        'Elementos Atingidas': '',
        'Ocorrido ao Longo da Via/Cruzamento': '',
        'Primeira Fonte de Informação': '',
        'Tipo de Cruzamento': '',
      },
      driverAgentsAndVehicles: {
        agents: [],
        missionCars: [],
        _localId: ''
      },
    },
    geom: {
      coordinates: [0, 0],
    },
    modified_by: '',
    created: '',
    modified: '',
    occurred_from: '',
    occurred_to: '',
    location_text: '',
    schema: '', 
  });

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [imagens, setImagens] = useState<IncidentImages[]>([]);

  const arrayImagens = useCallback(async () => {
    try {
      const { data: file } = await getImagesOfIncident(pathId);
      setImagens(file);
    } catch (error) {
      console.log('Erro ao buscar imagens do sinistro.')
    }
    
  }, [authHeader, pathId]);
  const history = useHistory();

  useEffect(() => {
    async function loadRegister(id: string) {
      setLoading(true);
      const groups = localStorage.getItem('groups')?.split(' ');
      if (groups) {
        groups.forEach((gr: string) => {
          if (gr === 'public') {
            setPublicGroup(true);
          } else if (gr === 'digitador') {
            setTypist(true);
          } else if (gr === 'tec_engenharia') {
            setTecEng(true);
          } else if (gr === 'geofi') {
            setGeofi(true);
          } else if (gr === 'admin') {
            setAdmin(true);
          }
        });
      }
      try {
        const result = await fetchIncidentById(id, {
          params: {
            details_only: (geofi || publicGroup || tecEng) && !(admin || typist) ? 'True' : 'False',
          }
        });
  
        setRegister(result.data);
      } catch {
        setSnackbar({
          open: true,
          message: 'Não foi encontrado o sinistro.',
        });
      } finally {
        setLoading(false);

      }
      
    }
    loadRegister(pathId);
    arrayImagens();
    if (register.created !== '') {
      setLoading(false);
    }
  }, [
    pathId,
    authHeader,
    admin,
    register.created,
    geofi,
    publicGroup,
    tecEng,
    typist,
    arrayImagens,
  ]);

  const navigate = (path: 'map' | 'records' | 'edit') => {
    if (path === 'records') {
      history.goBack();
      return;
    }
    if (path === 'edit') {
      history.push(`/editar/sinistro/${pathId}`);
      return;
    }

    const mapData = localStorage.getItem('incMapViewport');

    if (mapData) {
      localStorage.removeItem('incMapViewport');
      history.push({ pathname: '/mapa/sinistros', state: { viewport: mapData } });
    }
  };

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setActive(newValue);
  };

  return (
    <>
      {loading ? (
        <div className={styles.loadingContainer}>
          <CircularProgress className={styles.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <Container className={styles.container}>
          {(publicGroup || geofi || tecEng) && !(admin || typist) ? (
            <Box className={styles.box}>
              <ButtonGroup
                disableElevation
                variant="contained"
                size="small"
                className={styles.actionBtnsDiv}
              >
                <Button onClick={() => navigate('map')} className={styles.actionBtn}>
                  Voltar ao mapa
                </Button>
              </ButtonGroup>
              <Tabs
                variant="fullWidth"
                value={active}
                onChange={handleTabChange}
                TabIndicatorProps={{ style: { backgroundColor: Colors.secundary } }}
              >
                <Tab label="Detalhes do Incidente" />
              </Tabs>
            </Box>
          ) : (
            <Box className={styles.box}>
              <ButtonGroup
                disableElevation
                variant="contained"
                size="small"
                className={styles.actionBtnsDiv}
              >
                <Button onClick={() => navigate('map')} className={styles.actionBtn}>
                  Voltar ao mapa
                </Button>
                <Button onClick={() => navigate('edit')} className={styles.actionBtn}>
                  Editar sinistro
                </Button>
              </ButtonGroup>
              <Paper square>
                <Tabs
                  variant="fullWidth"
                  value={active}
                  onChange={handleTabChange}
                  TabIndicatorProps={{ style: { backgroundColor: Colors.main } }}
                >
                  <Tab label="Detalhes do Incidente" />
                  <Tab label="Vias" />
                  <Tab label="Envolvidos" />
                  <Tab label="Veículos" />
                  <Tab label="Imagens" />
                  <Tab label="Agentes e Viaturas" />
                </Tabs>
              </Paper>
            </Box>
          )}

          {active === 0 && (
            <>
              <Container className={styles.root}>
                <TableRegister
                  title={['ocorrido', 'criado']}
                  data={[
                    {
                      details: [
                        `${toDate(register.occurred_from)}`,
                        `${toDate(register.created!)}`,
                      ],
                    },
                  ]}
                />

                <TableRegister
                  title={['endereço 1', 'endereço 2']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Endereço 1']}`,
                        `${register.data.driverIncidenteDetails['Endereço 2']}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['bairro', 'numero/referencia']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Bairro}`,
                        `${register.data.driverIncidenteDetails['Numero Referencia']}`,
                      ],
                    },
                  ]}
                />
                <Container className={styles.containerMap}>
                  <MapMarker
                    point={[register.geom?.coordinates[1], register.geom?.coordinates[0]]}
                    notDragabble
                  />
                </Container>
                <TableRegister
                  title={['latitude', 'longitude']}
                  data={[
                    {
                      details: [
                        `${register.geom?.coordinates[1]}`,
                        `${register.geom?.coordinates[0]}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['iluminação', 'severidade']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Iluminação}`,
                        `${register.data.driverIncidenteDetails.Severidade}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['natureza', 'jurisdição']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Natureza}`,
                        `${register.data.driverIncidenteDetails.Jurisdição}`,
                      ],
                    },
                  ]}
                />

                <TableRegister
                  title={['tempo', 'uso do solo']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails.Tempo}`,
                        `${register.data.driverIncidenteDetails.Local}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['superfície da pista', 'controle de tráfego']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Superfície da Pista']}`,
                        `${register.data.driverIncidenteDetails['Controle de Tráfego']}`,
                      ],
                    },
                  ]}
                />
              </Container>

              <Container className={styles.small}>
                <TableRegister
                  title={['ocorrido']}
                  data={[
                    {
                      details: [`${toDate(register?.occurred_from)}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['criado']}
                  data={[
                    {
                      details: [`${toDate(register?.created!)}`],
                    },
                  ]}
                />

                <TableRegister
                  title={['endereço 1']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails['Endereço 1']}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['endereço 2']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails['Endereço 2']}`],
                    },
                  ]}
                />
                <Container className={styles.containerMap}>
                  <MapMarker
                    point={[register.geom.coordinates[1], register.geom.coordinates[0]]}
                    notDragabble
                  />
                </Container>
                <TableRegister
                  title={['latitude']}
                  data={[
                    {
                      details: [`${register.geom.coordinates?.[1]}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['longitude']}
                  data={[
                    {
                      details: [`${register.geom.coordinates?.[0]}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['iluminação']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Iluminação}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['severidade']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Severidade}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['natureza']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Natureza}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['jurisdição']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Jurisdição}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['tempo']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Tempo}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['uso do solo']}
                  data={[
                    {
                      details: [`${register.data.driverIncidenteDetails.Local}`],
                    },
                  ]}
                />
                <TableRegister
                  title={['superfície da pista']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Superfície da Pista']}`,
                      ],
                    },
                  ]}
                />
                <TableRegister
                  title={['controle de tráfego']}
                  data={[
                    {
                      details: [
                        `${register.data.driverIncidenteDetails['Controle de Tráfego']}`,
                      ],
                    },
                  ]}
                />
              </Container>
            </>
          )}
          {active === 1 && (
            <>
              <Container className={styles.root}>
                <TableRegister
                  title={[
                    'Nome',
                    'Tipo de pavimento',
                    'Faixas por sentido',
                    'Alinhamento horizontal',
                  ]}
                />
                {register.data.driverVia.map((streets) => (
                  <TableRegister
                    notDetails
                    key={`1${streets?.Nome}${Date.now()}`}
                    data={[
                      {
                        details: [
                          streets?.Nome,
                          streets?.['Tipo do Pavimento'],
                          streets?.['Faixa para Sentido'],
                          streets?.['Alinhamento Horizontal'],
                        ],
                      },
                    ]}
                    collapse={[
                      {
                        title: ['nome', 'sinalização horizontal'],
                        value: [streets?.Nome, streets?.['Sinalização Horizontal']],
                      },
                      {
                        title: ['sinalização vertical', 'alinhamento horizontal'],
                        value: [
                          streets?.['Sinalização Vertical'],
                          streets?.['Alinhamento Horizontal'],
                        ],
                      },
                      {
                        title: ['alinhamento vertical', 'obra de arte'],
                        value: [
                          streets?.['Alinhamento Vertical'],
                          `${toDate(streets?.['Obra de Arte'])}`,
                        ],
                      },
                      {
                        title: ['obras na pista', 'tipo da pista'],
                        value: [
                          `${toDate(streets?.['Obras na Pista'])}`,
                          streets?.['Tipo da Pista'],
                        ],
                      },
                      {
                        title: ['sinalização horizontal', 'sinalização vertical'],
                        value: [
                          streets?.['Sinalização Horizontal'],
                          streets?.['Sinalização Vertical'],
                        ],
                      },
                      {
                        title: ['condição da pista', 'condição da calçada'],
                        value: [
                          streets?.['Condição da Pista'],
                          streets?.['Condição da Calçada'],
                        ],
                      },
                      {
                        title: ['separação central'],
                        value: [streets?.['Separação Central']],
                      },
                    ]}
                  />
                ))}
              </Container>
              <Container className={styles.small}>
                {register.data.driverVia.map((streets) => (
                  <>
                    <Button
                      key={`2${streets?.Nome}${Date.now()}`}
                      onClick={handleOpen}
                      variant="outlined"
                      style={{ width: '100%', margin: '5% 0 2% 0' }}
                    >
                      Ver mais
                    </Button>
                    <TableRegister title={['nome']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.Nome],
                        },
                      ]}
                    />

                    <TableRegister title={['tipo de pavimento']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.['Tipo do Pavimento']],
                        },
                      ]}
                    />
                    <TableRegister title={['faixas por sentido']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.['Faixa para Sentido']],
                        },
                      ]}
                    />
                    <TableRegister title={['alinhamento horizontal']} />
                    <TableRegister
                      data={[
                        {
                          details: [streets?.['Alinhamento Horizontal']],
                        },
                      ]}
                    />
                    <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      className={styles.modal}
                      open={open}
                      onClose={handleClose}
                      closeAfterTransition
                      BackdropComponent={Backdrop}
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade in={open}>
                        <div className={styles.paper}>
                          <div className={styles.header}>Nome</div>
                          <p>{streets?.Nome}</p>
                          <div className={styles.header}>Sinalização Horizontal</div>
                          <p>{streets?.['Sinalização Horizontal']}</p>
                          <div className={styles.header}>Sinalização Vertical</div>
                          <p>{streets?.['Sinalização Vertical']}</p>
                          <div className={styles.header}>Alinhamento Horizontal</div>
                          <p>{streets?.['Alinhamento Horizontal']}</p>
                          <div className={styles.header}>Alinhamento Vertical</div>
                          <p>{streets?.['Alinhamento Vertical']}</p>
                          <div className={styles.header}>Obra de Arte</div>
                          <p>{streets?.['Obra de Arte']}</p>
                          <div className={styles.header}>Obras na Pista</div>
                          <p>{streets?.['Obras na Pista']}</p>
                          <div className={styles.header}>Tipo da Pista</div>
                          <p>{streets?.['Tipo da Pista']}</p>
                          <div className={styles.header}>Tipo do Pavimento</div>
                          <p>{streets?.['Tipo do Pavimento']}</p>
                          <div className={styles.header}>Faixa para Sentido</div>
                          <p>{streets?.['Faixa para Sentido']}</p>
                          <div className={styles.header}>Condição da Pista</div>
                          <p>{streets?.['Condição da Pista']}</p>
                          <div className={styles.header}>Condição da Calçada</div>
                          <p>{streets?.['Condição da Calçada']}</p>
                          <div className={styles.header}>Separação Central</div>
                          <p>{streets?.['Separação Central']}</p>
                        </div>
                      </Fade>
                    </Modal>
                  </>
                ))}
              </Container>
            </>
          )}
          {active === 2 && (
            <>
              <Container className={styles.root}>
                <TableRegister
                  title={
                    admin || typist
                      ? ['tipo de envolvido', 'gênero', 'idade', 'gravidade da lesão']
                      : ['tipo de pessoa', 'gravidade', 'gênero', 'idade']
                  }
                />
                {register.data.driverVitima.map((victims) => (
                  <TableRegister
                    notDetails
                    key={`3${victims?.Idade}${victims?.['Número da CNH']}${Date.now()}`}
                    data={
                      admin || typist
                        ? [
                            {
                              details: [
                                victims?.['Tipo de Pessoa'],
                                victims?.Sexo,
                                typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade === '-1'
                                  ? 'Não informado'
                                  : victims.Idade.toString(),
                                victims?.['Gravidade da Lesão'],
                              ],
                            },
                          ]
                        : [
                            {
                              details: [
                                victims?.['Tipo de Pessoa'],
                                victims?.['Gravidade da Lesão'],
                                victims?.Sexo,
                                typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade.toString(),
                              ],
                            },
                          ]
                    }
                    collapse={
                      admin || typist
                        ? [
                            {
                              title: ['Idade', 'Gênero'],
                              value: [
                                typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade.toString(),
                                victims?.Sexo,
                              ],
                            },
                            {
                              title: ['Nome', ' Número da CNH '],
                              value: [victims?.Nome, victims?.['Número da CNH']],
                            },
                            {
                              title: ['Usava Cinto ou Capacete', ' Data de Alta '],
                              value: [
                                victims?.['Usava Cinto ou Capacete'],
                                `${toDate(victims?.['Data de Alta'])}`,
                              ],
                            },
                            {
                              title: ['Data de Internação', 'Categoria do Condutor'],
                              value: [
                                `${toDate(victims?.['Data de Internação'])}`,
                                victims?.['Categoria do Condutor'],
                              ],
                            },
                            {
                              title: ['Exame de alcoolemia', 'Dosagem'],
                              value: [victims?.['Exame de alcoolemia'], victims?.Dosagem],
                            },
                            {
                              title: ['Situação do Condutor', 'Encaminhamento'],
                              value: [
                                victims?.['Situação do Condutor'],
                                victims?.Encaminhamento,
                              ],
                            },
                            {
                              title: ['Posição do passageiro', 'Evolução de caso'],
                              value: [
                                victims?.['Posição do passageiro'],
                                victims?.['Evolução de caso'],
                              ],
                            },
                            {
                              title: ['Tipo de Morte', 'Custo Geral'],
                              value: [
                                victims?.['Tipo de Morte'],
                                victims?.['Custo Geral'],
                              ],
                            },
                            {
                              title: [
                                'Número do cartão de saúde cidadão',
                                'Início de Reabilitação',
                              ],
                              value: [
                                victims?.['Número do cartão de saúde cidadão'],
                                `${toDate(victims?.['Início de Reabilitação'])}`,
                              ],
                            },
                            {
                              title: ['Fim da Reabilitação', 'Data do Óbito'],
                              value: [
                                `${toDate(victims?.['Fim da Reabilitação'])}`,
                                `${toDate(victims?.['Data do Óbito'])}`,
                              ],
                            },
                            {
                              title: ['Procedimentos realizados', ' Observações '],
                              value: [
                                victims?.['Procedimentos realizados'],
                                victims?.Observações,
                              ],
                            },
                            {
                              title: ['Lesões', 'Tipo de Envolvido'],
                              value: [
                                victims.Lesões?.join(', '),
                                victims?.['Tipo de Pessoa'],
                              ],
                            },
                            {
                              title: ['Gravidade da Lesão', 'Código Veículo'],
                              value: [
                                victims?.['Gravidade da Lesão'],
                                victims?.['Código Veículo'],
                              ],
                            },
                            {
                              title: ['Tipo Documento', 'Número Documento'],
                              value: [
                                victims?.['Tipo Documento'],
                                victims?.['Número Documento'],
                              ],
                            },
                            {
                              title: ['Data de Nascimento'],
                              value: [`${toDate(victims?.['Data de Nascimento'])}`],
                            },
                          ]
                        : [
                            {
                              title: ['Gênero', 'Idade'],
                              value: [
                                victims?.Sexo,
                                typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade.toString(),
                              ],
                            },
                            {
                              title: ['Usava cinto ou capacete', 'Exame de alcoolemia'],
                              value: [
                                victims?.['Usava Cinto ou Capacete'],
                                victims?.['Exame de alcoolemia'],
                              ],
                            },
                            {
                              title: ['Dosagem', 'Gravidade da Lesão'],
                              value: [victims?.Dosagem, victims?.['Gravidade da Lesão']],
                            },
                            {
                              title: ['Código do veículo', 'Tipo de pessoa'],
                              value: [
                                victims?.['Código Veículo'],
                                victims?.['Tipo de Pessoa'],
                              ],
                            },
                          ]
                    }
                  />
                ))}
              </Container>

              <Container className={styles.small}>
                {register.data.driverVitima.map((victims) => (
                  <>
                    <Button
                      key={`4${victims?.Idade}${victims?.['Número da CNH']}${Date.now()}`}
                      onClick={handleOpen}
                      variant="outlined"
                      style={{ width: '100%', margin: '5% 0 2% 0' }}
                    >
                      Ver mais
                    </Button>
                    {admin || typist ? (
                      <>
                        <TableRegister title={['tipo de envolvido']} />
                        <TableRegister
                          data={[
                            {
                              details: [victims?.['Tipo de Pessoa']],
                            },
                          ]}
                        />
                        <TableRegister title={['gênero']} />
                        <TableRegister
                          data={[
                            {
                              details: [victims?.Sexo],
                            },
                          ]}
                        />
                        <TableRegister title={['idade']} />
                        <TableRegister
                          data={[
                            {
                              details: [
                                typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade.toString(),
                              ],
                            },
                          ]}
                        />
                        <TableRegister title={['gravidade da lesão']} />
                        <TableRegister
                          data={[
                            {
                              details: [victims?.['Gravidade da Lesão']],
                            },
                          ]}
                        />

                        <Modal
                          aria-labelledby="transition-modal-title"
                          aria-describedby="transition-modal-description"
                          className={styles.modal}
                          open={open}
                          onClose={handleClose}
                          closeAfterTransition
                          BackdropComponent={Backdrop}
                          BackdropProps={{
                            timeout: 500,
                          }}
                        >
                          <Fade in={open}>
                            <div className={styles.paper}>
                              <div className={styles.header}>Idade</div>
                              <p>
                                {typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade}
                              </p>
                              <div className={styles.header}>Gênero</div>
                              <p>{victims?.Sexo}</p>
                              <div className={styles.header}>Nome</div>
                              <p>{victims?.Nome}</p>
                              <div className={styles.header}>Número da CNH</div>
                              <p>{victims?.['Número da CNH']}</p>
                              <div className={styles.header}>Usava Cinto ou Capacete</div>
                              <p>{victims?.['Usava Cinto ou Capacete']}</p>
                              <div className={styles.header}>Data de Alta</div>
                              <p>{toDate(victims?.['Data de Alta'])}</p>
                              <div className={styles.header}>Data de Internação</div>
                              <p>{toDate(victims?.['Data de Internação'])}</p>
                              <div className={styles.header}>Categoria do Condutor</div>
                              <p>{victims?.['Categoria do Condutor']}</p>
                              <div className={styles.header}>Exame de alcoolemia</div>
                              <p>{victims?.['Exame de alcoolemia']}</p>
                              <div className={styles.header}>Dosagem</div>
                              <p>{victims?.Dosagem}</p>
                              <div className={styles.header}>Situação do Condutor</div>
                              <p>{victims?.['Situação do Condutor']}</p>
                              <div className={styles.header}>Encaminhamento</div>
                              <p>{victims?.Encaminhamento}</p>
                              <div className={styles.header}>Posição do passageiro</div>
                              <p>{victims?.['Posição do passageiro']}</p>
                              <div className={styles.header}>Evolução de caso</div>
                              <p>{victims?.['Evolução de caso']}</p>
                              <div className={styles.header}>Tipo de Morte</div>
                              <p>{victims?.['Tipo de Morte']}</p>
                              <div className={styles.header}>Custo Geral</div>
                              <p>{victims?.['Custo Geral']}</p>
                              <div className={styles.header}>
                                Número do cartão de saúde cidadão
                              </div>
                              <p>{victims?.['Número do cartão de saúde cidadão']}</p>
                              <div className={styles.header}>Início de Reabilitação</div>
                              <p>{toDate(victims?.['Início de Reabilitação'])}</p>
                              <div className={styles.header}>Fim da Reabilitação</div>
                              <p>{toDate(victims?.['Fim da Reabilitação'])}</p>
                              <div className={styles.header}>Data do Óbito</div>
                              <p>{toDate(victims?.['Data do Óbito'])}</p>
                              <div className={styles.header}>Data de Nascimento</div>
                              <p>{toDate(victims?.['Data de Nascimento'])}</p>
                              <div className={styles.header}>
                                Procedimentos realizados
                              </div>
                              <p>{victims?.['Procedimentos realizados']}</p>
                              <div className={styles.header}>Observações</div>
                              <p>{victims?.Observações}</p>
                              <div className={styles.header}>Lesões</div>
                              <p>{victims?.Lesões?.join(', ')}</p>
                              <div className={styles.header}>Tipo de Envolvido</div>
                              <p>{victims?.['Tipo de Pessoa']}</p>
                              <div className={styles.header}>Gravidade da Lesão</div>
                              <p>{victims?.['Gravidade da Lesão']}</p>
                              <div className={styles.header}>Código Veículo</div>
                              <p>{victims?.['Código Veículo']}</p>
                              <div className={styles.header}>Tipo Documento</div>
                              <p>{victims?.['Tipo Documento']}</p>
                              <div className={styles.header}>Número Documento</div>
                              <p>{victims?.['Número Documento']}</p>
                            </div>
                          </Fade>
                        </Modal>
                      </>
                    ) : (
                      <>
                        <TableRegister title={['tipo de pessoa']} />
                        <TableRegister
                          data={[
                            {
                              details: [victims?.['Tipo de Pessoa']],
                            },
                          ]}
                        />
                        <TableRegister title={['gravidade']} />
                        <TableRegister
                          data={[
                            {
                              details: [victims?.['Gravidade da Lesão']],
                            },
                          ]}
                        />
                        <TableRegister title={['gênero']} />
                        <TableRegister
                          data={[
                            {
                              details: [victims?.Sexo],
                            },
                          ]}
                        />
                        <TableRegister title={['idade']} />
                        <TableRegister
                          data={[
                            {
                              details: [
                                typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade.toString(),
                              ],
                            },
                          ]}
                        />

                        <Modal
                          aria-labelledby="transition-modal-title"
                          aria-describedby="transition-modal-description"
                          className={styles.modal}
                          open={open}
                          onClose={handleClose}
                          closeAfterTransition
                          BackdropComponent={Backdrop}
                          BackdropProps={{
                            timeout: 500,
                          }}
                        >
                          <Fade in={open}>
                            <div className={styles.paper}>
                              <div className={styles.header}>Idade</div>
                              <p>
                                {typeof victims?.Idade === 'number' && victims.Idade < 0
                                  ? 'Não informado'
                                  : victims.Idade}
                              </p>
                              <div className={styles.header}>Gênero</div>
                              <p>{victims?.Sexo}</p>
                              <div className={styles.header}>Usava Cinto ou Capacete</div>
                              <p>{victims?.['Usava Cinto ou Capacete']}</p>
                              <div className={styles.header}>Exame de alcoolemia</div>
                              <p>{victims?.['Exame de alcoolemia']}</p>
                              <div className={styles.header}>Dosagem</div>
                              <p>{victims?.Dosagem}</p>
                              <div className={styles.header}>Tipo de Envolvido</div>
                              <p>{victims?.['Tipo de Pessoa']}</p>
                              <div className={styles.header}>Gravidade da Lesão</div>
                              <p>{victims?.['Gravidade da Lesão']}</p>
                              <div className={styles.header}>Código Veículo</div>
                              <p>{victims?.['Código Veículo']}</p>
                            </div>
                          </Fade>
                        </Modal>
                      </>
                    )}
                  </>
                ))}
              </Container>
            </>
          )}
          {active === 3 && (
            <>
              <Container className={styles.root}>
                <TableRegister
                  title={['tipo veículo', 'marca', 'categoria', 'espécie']}
                />
                {register.data.driverVeiculo.map((vehicle: Veiculo) => (
                  <TableRegister
                    notDetails
                    key={`5${vehicle?.Placa}${Date.now()}`}
                    data={[
                      {
                        details: [
                          vehicle?.['Tipo Veículo'],
                          vehicle?.Marca,
                          vehicle?.Categoria,
                          vehicle?.['Espécie'],
                        ],
                      },
                    ]}
                    collapse={
                      admin || typist
                        ? [
                            {
                              title: [' Tipo Veículo ', 'Placa'],
                              value: [vehicle?.['Tipo Veículo'], vehicle?.Placa],
                            },
                            {
                              title: ['Marca', 'Número do Ônibus'],
                              value: [vehicle?.Marca, vehicle?.['Número do Ônibus']],
                            },
                            {
                              title: ['Linha do Ônibus', 'Cor'],
                              value: [vehicle?.['Linha do Ônibus'], vehicle?.Cor],
                            },
                            {
                              title: ['Ano Fabricação', 'Espécie'],
                              value: [vehicle?.['Ano Fabricação'], vehicle?.Espécie],
                            },
                            {
                              title: ['Categoria', 'Legalizado'],
                              value: [vehicle?.Categoria, vehicle?.Legalizado],
                            },
                            {
                              title: ['Via de acesso', 'Manobra'],
                              value: [vehicle['Via de Acesso'], vehicle?.Manobra],
                            },
                            {
                              title: ['Outra manobra', 'Danificado'],
                              value: [
                                vehicle?.['Outra manobra'] || 'Não informado',
                                vehicle.Danificado,
                              ],
                            },
                            {
                              title: ['Categoria de Dano', 'Estrutura'],
                              value: vehicle['Formulario de Dano']
                                ? [
                                    vehicle?.['Formulario de Dano']?.DamageType,
                                    vehicle?.['Formulario de Dano']?.structure,
                                  ]
                                : ['Não Informado', 'Não Informado'],
                            },
                            {
                              title: ['Aluguel', 'Código Veículo'],
                              value: [vehicle?.Aluguel, vehicle['Código Veículo']],
                            },
                          ]
                        : [
                            {
                              title: [' Tipo Veículo ', 'Marca'],
                              value: [vehicle?.['Tipo Veículo'], vehicle?.Marca],
                            },
                            {
                              title: ['Categoria', 'Espécie'],
                              value: [vehicle?.Categoria, vehicle?.Espécie],
                            },
                            {
                              title: ['Código do veículo'],
                              value: [vehicle?.['Código Veículo']],
                            },
                          ]
                    }
                    damageForm={
                      vehicle['Formulario de Dano']
                        ? vehicle['Formulario de Dano'].DamageFormDetails
                        : undefined
                    }
                  />
                ))}
              </Container>

              <Container className={styles.small}>
                {register.data.driverVeiculo.map((vehicle) => (
                  <>
                    <Button
                      key={`6${vehicle?.Placa}${Date.now()}`}
                      onClick={handleOpen}
                      variant="outlined"
                      style={{ width: '100%', margin: '5% 0 2% 0' }}
                    >
                      Ver mais
                    </Button>
                    <TableRegister title={['tipo veículo']} />
                    <TableRegister
                      data={[
                        {
                          details: [vehicle?.['Tipo Veículo']],
                        },
                      ]}
                    />

                    <TableRegister title={['marca']} />
                    <TableRegister
                      data={[
                        {
                          details: [vehicle?.Marca],
                        },
                      ]}
                    />
                    <TableRegister title={['categoria']} />
                    <TableRegister
                      data={[
                        {
                          details: [vehicle?.Categoria],
                        },
                      ]}
                    />
                    <TableRegister title={['espécie']} />
                    <TableRegister
                      data={[
                        {
                          details: [vehicle?.Espécie],
                        },
                      ]}
                    />
                    {admin || typist ? (
                      <>
                        <Modal
                          aria-labelledby="transition-modal-title"
                          aria-describedby="transition-modal-description"
                          className={styles.modal}
                          open={open}
                          onClose={handleClose}
                          closeAfterTransition
                          BackdropComponent={Backdrop}
                          BackdropProps={{
                            timeout: 500,
                          }}
                        >
                          <Fade in={open}>
                            <div className={styles.paper}>
                              <div className={styles.header}>Tipo Veículo</div>
                              <p>{vehicle?.['Tipo Veículo']}</p>
                              <div className={styles.header}>Placa</div>
                              <p>{vehicle?.Placa}</p>
                              <div className={styles.header}>Marca</div>
                              <p>{vehicle?.Marca}</p>
                              <div className={styles.header}>Número do Ônibus</div>
                              <p>{vehicle?.['Número do Ônibus']}</p>
                              <div className={styles.header}>Linha do Ônibus</div>
                              <p>{vehicle?.['Linha do Ônibus']}</p>
                              <div className={styles.header}>Cor</div>
                              <p>{vehicle?.Cor}</p>
                              <div className={styles.header}>Ano Fabricação</div>
                              <p>{vehicle?.['Ano Fabricação']}</p>
                              <div className={styles.header}>Espécie</div>
                              <p>{vehicle?.Espécie}</p>
                              <div className={styles.header}>Categoria</div>
                              <p>{vehicle?.Categoria}</p>
                              <div className={styles.header}>Legalizado</div>
                              <p>{vehicle?.Legalizado}</p>
                              <div className={styles.header}>Manobra</div>
                              <p>{vehicle?.Manobra}</p>
                              <div className={styles.header}>Outra manobra</div>
                              <p>{vehicle?.['Outra manobra']}</p>
                              <div className={styles.header}>Danificado</div>
                              <p>{vehicle?.Danificado}</p>
                              {vehicle['Formulario de Dano'] && (
                                <>
                                  <div className={styles.header}>Estrutura</div>
                                  <p>{vehicle?.['Formulario de Dano'].structure}</p>
                                  <div className={styles.header}>
                                    Classificação de Dano
                                  </div>
                                  <p>{vehicle?.['Formulario de Dano'].DamageType}</p>
                                </>
                              )}
                              <div className={styles.header}>Aluguel</div>
                              <p>{vehicle?.Aluguel}</p>
                              <div className={styles.header}>Código Veículo</div>
                              <p>{vehicle?.['Código Veículo']}</p>
                              {vehicle['Formulario de Dano'] &&
                              vehicle?.['Formulario de Dano'].DamageFormDetails.length >
                                0 ? (
                                <>
                                  <Button
                                    onClick={() =>
                                      setDamageFormColapseControl((prev) => !prev)
                                    }
                                    variant="contained"
                                    style={{
                                      background: Colors.secundary,
                                      width: '100%',
                                      margin: '5% 0 2% 0',
                                      color: '#fff',
                                    }}
                                  >
                                    Formulario de Dano
                                  </Button>
                                  <Collapse
                                    in={damageFormColapseControl}
                                    timeout="auto"
                                    unmountOnExit
                                    style={{
                                      margin: '1rem 0',
                                      alignSelf: 'center',
                                      display: 'flex',
                                    }}
                                  >
                                    <Grid
                                      container
                                      spacing={2}
                                      direction="row"
                                      justify="center"
                                      alignItems="center"
                                      alignContent="center"
                                    >
                                      {vehicle[
                                        'Formulario de Dano'
                                      ].DamageFormDetails.map((element) => {
                                        return (
                                          <div
                                            key={element.label}
                                            className={styles.damageForm}
                                          >
                                            <Grid
                                              item
                                              xs={8}
                                              style={{
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center',
                                              }}
                                            >
                                              {element.label}
                                            </Grid>
                                            <Grid
                                              item
                                              xs={4}
                                              style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              {element.answer}
                                            </Grid>
                                          </div>
                                        );
                                      })}
                                    </Grid>
                                  </Collapse>
                                </>
                              ) : (
                                <Button
                                  disabled
                                  variant="contained"
                                  style={{
                                    opacity: '70%',
                                    background: Colors.secundary,
                                    width: '100%',
                                    margin: '5% 0 2% 0',
                                    color: '#fff',
                                  }}
                                >
                                  Formulário de Dano
                                </Button>
                              )}
                            </div>
                          </Fade>
                        </Modal>
                      </>
                    ) : (
                      <>
                        <Modal
                          aria-labelledby="transition-modal-title"
                          aria-describedby="transition-modal-description"
                          className={styles.modal}
                          open={open}
                          onClose={handleClose}
                          closeAfterTransition
                          BackdropComponent={Backdrop}
                          BackdropProps={{
                            timeout: 500,
                          }}
                        >
                          <Fade in={open}>
                            <div className={styles.paper}>
                              <div className={styles.header}>Tipo Veículo</div>
                              <p>{vehicle?.['Tipo Veículo']}</p>
                              <div className={styles.header}>Marca</div>
                              <p>{vehicle?.Marca}</p>
                              <div className={styles.header}>Categoria</div>
                              <p>{vehicle?.Categoria}</p>
                              <div className={styles.header}>Espécie</div>
                              <p>{vehicle?.Espécie}</p>
                              <div className={styles.header}>Código Veículo</div>
                              <p>{vehicle?.['Código Veículo']}</p>
                            </div>
                          </Fade>
                        </Modal>
                      </>
                    )}
                  </>
                ))}
              </Container>
            </>
          )}
          {active === 4 && (
            <>
              <Container className={styles.root2}>
                <List component="ul" className={styles.listImages}>
                  {imagens.map((item, index) => (
                    <ListItem key={item.uuid} className={styles.imageItem}>
                      <a href={item.path} target="_blank" rel="noreferrer">
                        <img
                          src={item.path}
                          key={item.uuid}
                          alt={`Foto do Sinistro ${index}`}
                          className={styles.image}
                        />
                      </a>
                      <div className={styles.descContainer}>
                        <Typography variant="subtitle2" style={{ marginBottom: 5 }}>
                          Descrição
                        </Typography>
                        <Typography className={styles.imgDescription}>
                          {item.description}
                        </Typography>
                      </div>
                    </ListItem>
                  ))}
                </List>
              </Container>
            </>
          )}
          {active === 5 && (
            <>
              <Container className={styles.root}>
                <Typography className={styles.headerTitle}>
                  Matrícula de Agente
                </Typography>
                {!register.data.driverAgentsAndVehicles && (
                  <Typography className={styles.textRow}>
                    Não há dados cadastrados
                  </Typography>
                )}

                {register.data.driverAgentsAndVehicles &&
                  register.data.driverAgentsAndVehicles.agents.map((agent) => {
                    return (
                      <Typography className={styles.textRow}>
                        {agent.Matrícula || 'Não informado'}
                      </Typography>
                    );
                  })}

                <Typography className={styles.headerTitle}>ID de Viatura</Typography>
                {!register.data.driverAgentsAndVehicles && (
                  <Typography className={styles.textRow}>
                    Não há dados cadastrados
                  </Typography>
                )}
                {register.data.driverAgentsAndVehicles &&
                  register.data.driverAgentsAndVehicles.missionCars.map((missionCar) => {
                    return (
                      <Typography className={styles.textRow}>
                        {missionCar.id || 'Não informado'}
                      </Typography>
                    );
                  })}
              </Container>
            </>
          )}
          <ShowSnackbar
            open={snackBar.open}
            message={snackBar.message}
            setSnackbar={setSnackbar}
          />
        </Container>
      )}
    </>
  );
};

export default RegisterIncident;
